/*
Copyright (c) 2021, 
*/

import { create } from 'apisauce';
import { maverickPortalconfig } from '../../config/apiConfig';
import maverickPortalApiEndPoint from '../../config/apiEndPoint';
import AuthService from '../authService/AuthService';

const host = maverickPortalconfig.env[0].DEV.hostname;

function maverickPortalhttp() {
  const http = create({});

  const checkError = response => {
    if (response.problem !== null && response.problem === 'NETWORK_ERROR') {
      const ErrorList = [
        {
          ErrorCode: 'NETWORK_ERROR',
          ErrorType: 'Network Error',
          ErrorMessage: 'Please check your network setting and try again.'
        }
      ];
      response.data = { ErrorList };
      return response;
    }
    const ErrorList = [
      {
        ErrorCode: 'UNKNOWN_ERROR',
        ErrorType: 'Unknown Error',
        ErrorMessage: 'Unknown error occurred. Please try again later'
      }
    ];
    response.data = { ErrorList };
    return response;
  };

  const checkResponse = response => {
    if (response.status === 200 && response.ok) {
      return response;
    }
    return checkError(response);
  };

  const onResponseSuccess = response => {
    return checkResponse(response);
  };

  http.addResponseTransform(onResponseSuccess);
  
  const createRequest = async (path, method, _data) => {
    const url = host + path;
    // http.setHeaders({
    //   'Content-Type': 'application/json',
    //   'Access-Control-Allow-Origin': '*'
    // });
    const token = AuthService.getToken();
    switch (method.toUpperCase()) {
      case 'GET':
        http.setHeaders({ Authorization: token });
        return http.get(url);
      case 'POST':
        if (path === maverickPortalApiEndPoint.login.url) {
          return http.post(url, _data);
        } else if (
          path === maverickPortalApiEndPoint.createProject.url ||
          path === maverickPortalApiEndPoint.editProject.url ||
          path === maverickPortalApiEndPoint.addQuestion.url
        ) {
          http.setHeaders({
            'Content-Type': 'multipart/form-data',
            Authorization: token
            // 'Access-Control-Allow-Origin': '*'
          });
          return http.post(url, _data);
        }
        http.setHeaders({
          Authorization: token,
          'Content-Type': 'application/json'
          // 'Access-Control-Allow-Origin': '*'
        });
        return http.post(url, _data);
      case 'DELETE':
        http.setHeaders({ Authorization: token });
        return http.delete(url);

      case 'PUT':
        http.setHeaders({ Authorization: token });
        return http.put(url, _data);

      case 'PATCH':
        http.setHeaders({ Authorization: token });
        return http.patch(url, _data);

      default:
        break;
    }
    return true;
  };

  const createRequestWithoutBase = async (path, method, _data, token) => {
    const url = path;

    switch (method.toUpperCase()) {
      case 'GET':
        http.setHeaders({ Authorization: token });
        return http.get(url);
      case 'POST':
        if (path === maverickPortalApiEndPoint.login.url) {
          return http.post(url, _data);
        } else if (
          path === maverickPortalApiEndPoint.createProject.url ||
          path === maverickPortalApiEndPoint.editProject.url
        ) {
          http.setHeaders({
            Authorization: token
            // 'Access-Control-Allow-Origin': '*'
          });
          return http.post(url, _data);
        }
        http.setHeaders({
          Authorization: token,
          'Content-Type': 'application/json'
        });
        return http.post(url, _data);
      case 'DELETE':
        http.setHeaders({ Authorization: token });
        return http.delete(url);

      case 'PUT':
        http.setHeaders({ Authorization: token });
        return http.put(url, _data);

      case 'PATCH':
        http.setHeaders({ Authorization: token });
        return http.patch(url, _data);

      default:
        break;
    }
    return true;
  };

  return {
    makeRequest: createRequest,
    makeRequestWithoutBase: createRequestWithoutBase
  };
}
export default maverickPortalhttp();
